module.exports = __webpack_public_path__ + "static/a-titan-steps-into-a-galaxy-far-far-away-133edbd17081fdb80eecc1e0c3074571.jpg";